import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Firebase } from '../../lib/firebase';

import { Link, withRouter } from 'react-router-dom';


import { PageView } from '../../web/components/Tracking';

import {
  getCardsStudentZole, // need update
  getAutomatedStatus,
  playCardStudentZole, // need update
  getCurrentTable,
  getGlobalParams,
  selectGameTypeStudentZole, // need update
  getPlayers,
  getPlayerPosition,
  getCurrentTurn,
  getSittingOut,
  getLargePlayer,
  getCurrentType,
  getNextTimeStamp,
  getUnlimitedTimerStarted,
  resetGameStore,
  closeResultNotification,
  setCurRoomId,
  fetchInitialRoomData,
  refreshLastToken,
  getCardsOnTable,
  getFirstToGo,
} from '../../actions/game';

import {
  setSupportAsRead,
  updateUserLastLogin,
  closeLevelNotification,
  removeActiveRoom,
  getTimeOffset,
  getIgnoredPlayers,
} from '../../actions/member';

import {
  endRoom2,
  leaveRoom,
  sendGift,
  getGifts,
  getRoomGifts,
  getProfanitiesList,
  readChat,
  getDrinkGifts,
} from '../../actions/room';

import { getPoints, cancelPointsListeners, getPules } from '../../actions/points';

import { toggleScoreTable, toggleMobileScoreTable, resetFilterRoomsExit, } from '../../actions/userSettings';

import { setLoading } from '../../actions/state';

// import buttonClickedSound from '../../sounds/button.mp3';
// import putCardOnTableSound from '../../sounds/put_card_on_table.mp3';

import * as constants from '../../constants/constants';

const buttonClickedSound = '/sounds/button.mp3';
const putCardOnTableSound = '/sounds/put_card_on_table.mp3';

class StudentZole extends Component {
  static propTypes = {
    Layout: PropTypes.func.isRequired,
    member: PropTypes.shape().isRequired,
    history: PropTypes.shape(),
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    state: PropTypes.shape({
      isLoading: PropTypes.bool,
    }),
    fetchCards: PropTypes.func.isRequired,
    playACard: PropTypes.func.isRequired,
    lastRound: PropTypes.bool,
    fetchCurrentTable: PropTypes.func.isRequired,
    fetchGlobalParams: PropTypes.func.isRequired,
    fetchPlayers: PropTypes.func.isRequired,
    fetchPlayerPosition: PropTypes.func.isRequired,
    chooseGameType: PropTypes.func.isRequired,
    fetchCurrentTurn: PropTypes.func.isRequired,
    fetchSittingOut: PropTypes.func.isRequired,
    fetchLargePlayer: PropTypes.func.isRequired,
    fetchCurrentType: PropTypes.func.isRequired,
    fetchNextTimeStamp: PropTypes.func.isRequired,
    fetchUnlimitedTimerStarted: PropTypes.func.isRequired,
    endThisRoom: PropTypes.func.isRequired,
    leaveThisRoom: PropTypes.func.isRequired,
    resetStore: PropTypes.func.isRequired,
    closeResultNotif: PropTypes.func.isRequired,
    setSupportRead: PropTypes.func.isRequired,
    showNotification: PropTypes.func.isRequired,
    sendAGift: PropTypes.func.isRequired,
    fetchGifts: PropTypes.func.isRequired,
    fetchDrinkGifts: PropTypes.func.isRequired,
    fetchRoomGifts: PropTypes.func.isRequired,
    updateLastLogin: PropTypes.func.isRequired,
    closeLevelUpNotification: PropTypes.func.isRequired,
    removeCurActiveRoom: PropTypes.func.isRequired,
    setLoadingFunc: PropTypes.func.isRequired,
    fetchIgnoredPlayers: PropTypes.func.isRequired,
    fetchAutomatedStatus: PropTypes.func.isRequired,
    toggleFullscreen: PropTypes.func.isRequired,
    lastRoom: PropTypes.string,
    myPos: PropTypes.string,
    globalParams: PropTypes.shape(),
    userSettings: PropTypes.shape(),
    toggleScoreTableFunc: PropTypes.func.isRequired,
    toggleMobileScoreTableFunc: PropTypes.func.isRequired,
    currentType: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.string),
    automated: PropTypes.bool,
    isFullscreen: PropTypes.bool,
    isFullscreenEnabled: PropTypes.bool,
    isWebVersion: PropTypes.bool,
    profanitiesList: PropTypes.shape(),
    profanitiesNotification: PropTypes.string,
    notificationSettings: PropTypes.shape(),
    gameSettings: PropTypes.shape(),
    setRoomId: PropTypes.func.isRequired,
    fetchInitialData: PropTypes.func.isRequired,
    refreshDbLastToken: PropTypes.func.isRequired,
    getOffset: PropTypes.func.isRequired,
    fetchProfanitiesList: PropTypes.func.isRequired,
    cardsOnTable: PropTypes.arrayOf(PropTypes.string),
    fetchCardsOnTable: PropTypes.func.isRequired,
    toggleNewDesign: PropTypes.func.isRequired,
    toggleScreenMode: PropTypes.func.isRequired,
    players: PropTypes.shape(),
    screenMode: PropTypes.string,
    fontMode: PropTypes.string,
    toggleFont: PropTypes.func.isRequired,
    resetFilterRooms: PropTypes.func.isRequired,
    bannerVisible: PropTypes.bool,
  };

  static defaultProps = {
    match: null,
    history: {},
    state: {},
    globalParams: {},
    userSettings: {},
    lastRoom: null,
    myPos: null,
    currentType: null,
    cards: null,
    automated: false,
    isFullscreen: false,
    isFullscreenEnabled: false,
    isWebVersion: false,
    profanitiesList: null,
    profanitiesNotification: null,
    notificationSettings: null,
    gameSettings: null,
    cardsOnTable: [],
    players: {},
    screenMode: constants.SCREEN_MODE.normal,
    fontMode: constants.FONT_MODE.normal,
    lastRound: false,
    bannerVisible: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      roomId: '',
      loading: true,
      uid: '',
      roomClosing: false,
      cardPlayed: false,
      errorNotification: null,
      showEndResultModal: false,
      currentTableLoaded: true,
      cardsOnLoading: true,
    };

    this.buttonClickedAudio = new Audio(buttonClickedSound);
    this.putCardOnTableAudio = new Audio(putCardOnTableSound);

  }


  componentWillMount = () => {
    const {
      match,
      fetchPlayerPosition,
      fetchLargePlayer,
      fetchCurrentTable,
      fetchCurrentTurn,
      fetchFirstToGo,
      fetchSittingOut,
      fetchCurrentType,
      fetchGlobalParams,
      fetchNextTimeStamp,
      fetchUnlimitedTimerStarted,
      resetStore,
      lastRoom,
      setRoomId,
      refreshDbLastToken,
      fetchIgnoredPlayers,
      getOffset,
      fetchAutomatedStatus,
      fetchProfanitiesList,
    } = this.props;

    const unsubscribe = Firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log('user', { user });

        const roomId = match && match.params && match.params.id ? match.params.id : null;

        if (roomId) {
          resetStore(lastRoom, roomId).then(() => {
            getOffset();
            refreshDbLastToken();

            fetchProfanitiesList();

            fetchCurrentTable(roomId).then(() => {
              this.setState({ currentTableLoaded: true });
            });
            fetchCurrentTurn(roomId);
            fetchFirstToGo(roomId);
            fetchSittingOut(roomId);
            fetchCurrentType(roomId);
            fetchGlobalParams(roomId);
            fetchNextTimeStamp(roomId);
            fetchUnlimitedTimerStarted(roomId);

            this.fetchPlayers(roomId);

            fetchLargePlayer(roomId);
            fetchPlayerPosition(roomId).then(() => {
              this.fetchCards(roomId);
              fetchAutomatedStatus(roomId);
            });
            this.fetchRoomGifts(roomId);

            setRoomId(roomId);

            fetchIgnoredPlayers();
            this.fetchCardsOnTable(roomId);

            this.setState({ roomId, uid: user.uid });
          }).catch((err) => {
            console.log(err);

            fetchProfanitiesList();

            fetchCurrentTable(roomId).then(() => {
              this.setState({ currentTableLoaded: true });
            });
            fetchCurrentTurn(roomId);
            fetchFirstToGo(roomId);
            fetchSittingOut(roomId);
            fetchCurrentType(roomId);
            fetchGlobalParams(roomId);
            fetchNextTimeStamp(roomId);
            fetchUnlimitedTimerStarted(roomId);

            this.fetchPlayers(roomId);

            fetchLargePlayer(roomId);

            fetchPlayerPosition(roomId).then(() => {
              this.fetchCards(roomId);
              fetchAutomatedStatus(roomId);
            });
            this.fetchRoomGifts(roomId);

            fetchIgnoredPlayers();
            this.fetchCardsOnTable(roomId);

            this.setState({ roomId, uid: user.uid });
          });
        }
      }
    });
  };

  componentDidMount() {
    PageView();
  }

  componentDidUpdate(prevProps) {
    const { myPos, member, history, globalParams, players } = this.props;
    const { roomId } = this.state;

    if (prevProps.globalParams && this.props && prevProps.myPos !== myPos) {
      this.fetchCards(roomId);
    }

    console.log('ZOLE componentDidUpdate', member.activeRoom, roomId);

    if (roomId && member && member.activeRoom && member.activeRoom !== roomId) {
      console.log('member.activeRoom chganged, redirect to the new room');
      this.setState({ roomId: member.activeRoom });
      history.push(`/zole/${member.activeRoom}`);

      this.refetchData(member.activeRoom);
    }

    if (roomId && member && member.role !== 'admin' && !member.activeRoom && globalParams && !globalParams.roomClosed, players && players.playerList && member.uid) {
      console.log('No member.activeRoom data, check to redirect', globalParams, roomId, member.activeRoom, players);

      if (globalParams.gameState && globalParams.party && globalParams.roomId && globalParams.roomId === roomId) {
        if ((players.player1 && players.player1.uid !== member.uid) && (players.player2 && players.player2.uid !== member.uid)
          && (players.player3 && players.player3.uid !== member.uid) && (players.player4 && players.player4.uid !== member.uid)) {

          console.log('Call history.push for redirect as not in correct room', globalParams.roomId, roomId, member.activeRoom);

          history.push(`/`);
        }
      }
    } else if (roomId && member && member.role !== 'admin' && !member.activeRoom && globalParams && globalParams.roomId && globalParams.roomId === roomId && !players && globalParams.gameState && globalParams.party && globalParams.roomClosed) {
      console.log('Call history.push for redirect as not in correct room 222', globalParams.roomId, roomId, member.activeRoom);

      history.push(`/`);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.endTimeoutId);
  }

  refetchData = (newRoomId) => {
    const {
      fetchLargePlayer,
      fetchCurrentTable,
      fetchCurrentTurn,
      fetchFirstToGo,
      fetchCurrentType,
      fetchGlobalParams,
      fetchNextTimeStamp,
      fetchUnlimitedTimerStarted,
      fetchPlayerPosition,
      fetchAutomatedStatus,
      fetchSittingOut,

      cancelListeners,
      fetchPules,
      fetchPoints,
      readChatMessages,
    } = this.props;

    const { roomId } = this.state;

    if (newRoomId) {
      fetchCurrentTable(newRoomId).then(() => {
        this.setState({ currentTableLoaded: true });
      });
      fetchCurrentTurn(newRoomId);
      fetchFirstToGo(newRoomId);
      fetchSittingOut(newRoomId);
      fetchCurrentType(newRoomId);
      fetchGlobalParams(newRoomId);
      fetchNextTimeStamp(newRoomId);
      fetchUnlimitedTimerStarted(newRoomId);

      this.fetchPlayers(newRoomId);

      fetchLargePlayer(newRoomId);

      fetchPlayerPosition(newRoomId).then(() => {
        this.fetchCards(newRoomId);
        fetchAutomatedStatus(newRoomId);
      });
      this.fetchRoomGifts(newRoomId);
      this.fetchCardsOnTable(newRoomId);

      console.log('call cancelListeners');
      cancelListeners().then(() => {
        fetchPules(newRoomId);
        fetchPoints(newRoomId);
      });
      readChatMessages(newRoomId);

      this.setState({ roomId: newRoomId, showEndResultModal: false });

    } else if (roomId) {
      fetchCurrentTable(roomId).then(() => {
        this.setState({ currentTableLoaded: true });
      });
      fetchCurrentTurn(roomId);
      fetchFirstToGo(roomId);
      fetchCurrentType(roomId);
      fetchGlobalParams(roomId);
      fetchNextTimeStamp(roomId);
      fetchUnlimitedTimerStarted(roomId);

      fetchLargePlayer(roomId);
      this.fetchCardsOnTable(roomId);

      this.fetchCards(roomId);
    }
  }

  fetchCards = (roomId) => {
    const { fetchCards } = this.props;

    return fetchCards(roomId).catch(err => this.setState({
      loading: false,
      error: err,
    }));
  };

  fetchGifts = () => {
    const { fetchGifts } = this.props;
    const { giftsFetched } = this.state;

    if (!giftsFetched) {
      fetchGifts();
      this.setState({ giftsFetched: true });
    }
  };

  fetchDrinkGifts = () => {
    const { fetchDrinkGifts } = this.props;
    const { drinkGiftsFetched } = this.state;

    if (!drinkGiftsFetched) {
      fetchDrinkGifts();
      this.setState({ drinkGiftsFetched: true });
    }
  };

  fetchRoomGifts = (roomId) => {
    const { fetchRoomGifts } = this.props;

    return fetchRoomGifts(roomId);
  };

  endThisRoom = () => {
    const { endThisRoom, globalParams } = this.props;
    const { roomId } = this.state;

    if (
      globalParams
      && !globalParams.roomClosed
    ) {
      return endThisRoom(roomId).then((res) => {
        if (res && res === 'refetch') {
          this.refetchData();
        }
      }).catch((err) => {
        this.setState({
          loading: false,
          error: err,
        });
      });
    }
    return null;
  };

  fetchPlayers = (roomId) => {
    const { fetchPlayers } = this.props;

    return fetchPlayers(roomId)
      .catch(err => this.setState({
        loading: false,
        error: err,
      }));
  };

  playCard = ({ selectedCard, myPos }) => {
    const { playACard, globalParams, userSettings, soundOn } = this.props;
    const { roomId, cardPlayed } = this.state;

    if (!cardPlayed) {
      if (globalParams && globalParams.gameState !== 'burry') {
        this.setState({ cardPlayed: true });
      }

      if (globalParams && globalParams.gameState === 'burry') {
        if (soundOn) {
          console.log('playSound');
          const putCardOnTableAudio = new Audio(putCardOnTableSound);
          const playPromise = putCardOnTableAudio.play();
          // const playPromise = this.putCardOnTableAudio.play();
          if (playPromise !== undefined) {
            playPromise
              .then(_ => {
                // Automatic playback started!
                // Show playing UI.
                console.log("audio played auto");
              })
              .catch(error => {
                // Auto-play was prevented
                // Show paused UI.
                console.log("playback prevented", error);
              });
          }
        }
      }

      return playACard(selectedCard, roomId, myPos, globalParams.gameState)
        .then(() => {
          this.setState({ cardPlayed: false });
        })
        .catch((err) => {
          this.setState({
            loading: false,
            error: err,
            cardPlayed: false,
          });
        });
    }

    setTimeout(() => {
      this.setState({ cardPlayed: false });
    }, 400);

    return null;
  };

  chooseGameType = (selectedType) => {
    const { chooseGameType } = this.props;
    const { roomId } = this.state;

    return chooseGameType(selectedType, roomId).catch(err => this.setState({
      loading: false,
      error: err,
    }));
  };

  sendGift = (roomId, giftId, comment, players, drink) => {
    const { sendAGift } = this.props;

    return new Promise((resolve) => {
      sendAGift(roomId, giftId, comment, players, drink)
        .then((res) => {
          if (res.data && res.data.data && res.data.data.status === 'success') {
            resolve('success');
          } else if (
            res.data
            && res.data.data
            && res.data.data.status === 'error'
          ) {
            resolve('error');
            this.setState({ errorNotification: res.data.data.message });
          }
        })
        .catch(err => this.setState({
          error: err,
        }));
    });
  };

  resetErrorNotification = () => {
    this.setState({ errorNotification: '' });
  };

  leaveRoom = ({ init, leaveReason }) => {
    const {
      history,
      leaveThisRoom,
      updateLastLogin,
      removeCurActiveRoom,
      resetStore,
      globalParams,
      lastRoom,
      resetFilterRooms,
    } = this.props;
    const { roomId, uid } = this.state;

    console.log('leaveRoom11111111');

    resetFilterRooms(uid);
    if (init) {
      leaveThisRoom({ roomId, init, leaveReason });
    } else if (globalParams) {
      console.log('leaveRoom11112222', uid, globalParams.fourthPlayerMisse, globalParams.roomClosed);

      if (uid && globalParams.fourthPlayerMissed && globalParams.fourthPlayerMissed === uid) {
        updateLastLogin();
        resetStore(lastRoom, roomId);
        removeCurActiveRoom().then(() => {
          console.log('call history.push');
          history.push('/');
        });
      } else if (!globalParams.roomClosed) {
        console.log('leaveRoom11114444');
        leaveThisRoom({ roomId, leaveReason }).then((res) => {
          if (res.data.status === 'success') {
            console.log('leaveRoom sucess');

            if (globalParams.fourPRoom && globalParams.tournamentRoom) {
              updateLastLogin();
              resetStore(lastRoom, roomId);
              removeCurActiveRoom().then(() => {
                console.log('call history.push');
                history.push('/');
              });
            }
          } else if (
            res.data.status === 'error'
            && res.data.message === 'notInRoom'
          ) {
            updateLastLogin();
            resetStore(lastRoom, roomId);
            removeCurActiveRoom().then(() => {
              console.log('call history.push');
              history.push('/');
            });
          }

          return null;
        });
      } else {
        console.log('leaveRoom11113333');

        updateLastLogin();
        resetStore(lastRoom, roomId);
        removeCurActiveRoom().then(() => {
          console.log('call history.push');
          history.push('/');
        });
      }
    }
  }

  closeResultNotif = () => {
    const { closeResultNotif } = this.props;
    const { roomId } = this.state;

    return closeResultNotif(roomId)
      .then(() => {
        this.setState({ quitRoundPressed: false });
      })
      .catch(err => console.log(err));
  }

  playButtonSound = () => {
    const { userSettings, soundOn } = this.props;

    if (soundOn) {
      const buttonClickedAudio = new Audio(buttonClickedSound);
      const playPromise = buttonClickedAudio.play();
      // const playPromise = this.buttonClickedAudio.play();
      if (playPromise !== undefined) {
        playPromise
          .then(_ => {
            // Automatic playback started!
            // Show playing UI.
            console.log("audio played auto");
          })
          .catch(error => {
            // Auto-play was prevented
            // Show paused UI.
            console.log("playback prevented", error);
          });
      }
    }
  }

  setShowEndResultModal = (value) => {
    console.log('setShowEndResultModal', value);
    if (value === undefined) value = true;
    this.setState({
      showEndResultModal: value,
    });
  }

  fetchCardsOnTable = (roomId) => {
    const { fetchCardsOnTable } = this.props;
    this.setState({ cardsOnLoading: true });
    fetchCardsOnTable(roomId)
      .then(res => {
        this.setState({ cardsOnLoading: false })
      });
  }

  toggleCardsOnLoading = () => {
    this.setState({ cardsOnLoading: true });
  }

  render = () => {
    const {
      Layout,
      member,
      //  history,
      userSettings,
      state,
      showNotification,
      //  blockThisUser,
      //  unBlockThisUser,
      closeLevelUpNotification,
      setLoadingFunc,
      toggleScoreTableFunc,
      toggleMobileScoreTableFunc,
      setSupportRead,
      globalParams,
      currentType,
      cards,
      automated,
      myPos,
      isFullscreen,
      isFullscreenEnabled,
      isWebVersion,
      toggleFullscreen,
      //  setProfanitiesNotif,
      profanitiesList,
      profanitiesNotification,
      notificationSettings,
      gameSettings,
      fetchCardsOnTable,
      cardsOnTable,
      toggleNewDesign,
      toggleScreenMode,
      players,
      screenMode,
      fontMode,
      toggleFont,
      lastRound,
      soundOn,
      bannerVisible,
    } = this.props;

    const {
      loading,
      error,
      roomId,
      uid,
      roomClosing,
      //  closeErrorSubmit,
      quitRoundPressed,
      errorNotification,
      showEndResultModal,
      currentTableLoaded,
      cardsOnLoading,
    } = this.state;

    // console.log('showEndResultModal test', showEndResultModal);

    if (globalParams && roomId) {
      if (
        !roomClosing
        && globalParams
        && roomId
        && roomId === globalParams.roomId
        && globalParams.closeReason
        && globalParams.roomClosed
      ) {
        this.setState({
          roomClosing: true,
          //  closeReason: globalParams.closeReason,
        });

        let timeoutLength = 4000;

        if (globalParams.closeReason?.reason === 'leftRoom' || globalParams.closeReason?.reason === 'missedTurn') {
          timeoutLength = 1200;
        }

        this.endTimeoutId = setTimeout(() => {
          console.log('execute timeout');

          this.setState({
            //  closeReason: null,
            showEndResultModal: true,
          });
        }, timeoutLength);
      }

      if (state.isLoading) {
        setLoadingFunc(false);
      }

      return (
        <Layout
          key={roomId}
          member={{
            ...member,
            supportChat: null,
            supportChatStatus: null,
          }}
          supportChat={member.supportChat}
          supportChatStatus={member.supportChatStatus}
          user={uid}
          roomId={roomId}
          error={error}
          loading={loading}

          globalParams={globalParams}
          currentType={currentType}
          cards={cards}
          automated={automated}
          myPos={myPos}
          showEndResultModal={showEndResultModal}
          quitRoundPressed={quitRoundPressed}
          errorNotification={errorNotification}
          currentTableLoaded={currentTableLoaded}
          soundOn={soundOn}
          userSettings={userSettings || {}}

          // Functions
          //  closeErrorSubmit={closeErrorSubmit}
          showNotification={showNotification}
          playCard={this.playCard}
          chooseGameType={this.chooseGameType}
          endRoom={this.endThisRoom}
          //  setLastRound={this.setLastRound}
          leaveRoom={this.leaveRoom}
          quitRound={this.quitRound}
          closeResultNotif={this.closeResultNotif}
          //  resetCloseErrorSubmit={this.resetCloseErrorSubmit}
          //  sendSupportMessage={this.sendSupportMessage}
          setSupportAsRead={setSupportRead}
          resetErrorNotification={this.resetErrorNotification}
          closeLevelNotification={closeLevelUpNotification}
          sendGift={this.sendGift}
          //  blockUser={blockThisUser}
          //  unBlockUser={unBlockThisUser}
          playButtonSound={this.playButtonSound}
          fetchGifts={this.fetchGifts}
          fetchDrinkGifts={this.fetchDrinkGifts}
          setShowEndResultModal={this.setShowEndResultModal}
          toggleScoreTable={toggleScoreTableFunc}
          toggleMobileScoreTable={toggleMobileScoreTableFunc}
          isFullscreen={isFullscreen}
          isFullscreenEnabled={isFullscreenEnabled}
          isWebVersion={isWebVersion}
          toggleFullscreen={toggleFullscreen}
          //  setProfanitiesNotif={setProfanitiesNotif}
          profanitiesList={profanitiesList}
          profanitiesNotification={profanitiesNotification}
          notificationSettings={notificationSettings}
          gameSettings={gameSettings}
          cardsOnTable={cardsOnTable}
          fetchCardsOnTable={this.fetchCardsOnTable}
          toggleNewDesign={toggleNewDesign}
          toggleScreenMode={toggleScreenMode}
          players={players}
          cardsOnLoading={cardsOnLoading}
          toggleCardsOnLoading={this.toggleCardsOnLoading}
          screenMode={screenMode}
          fontMode={fontMode}
          toggleFont={toggleFont}
          lastRound={lastRound}
          bannerVisible={bannerVisible}
        />
      );
    }

    return (
      <Layout
        // Params
        key={roomId}
        member={{
          ...member,
          supportChat: null,
          supportChatStatus: null,
        }}
        supportChat={member.supportChat}
        supportChatStatus={member.supportChatStatus}
        user={uid}
        roomId={roomId}
        error={error}
        loading={loading}
        //  quitRoundPressed={quitRoundPressed}
        currentTableLoaded={currentTableLoaded}
        soundOn={soundOn}
        userSettings={userSettings || {}}

        // Functions
        //  closeErrorSubmit={closeErrorSubmit}
        showNotification={showNotification}
        playCard={this.playCard}
        chooseGameType={this.chooseGameType}
        endRoom={this.endThisRoom}
        //  setLastRound={this.setLastRound}
        leaveRoom={this.leaveRoom}
        //  quitRound={this.quitRound}
        closeResultNotif={this.closeResultNotif}
        //  resetCloseErrorSubmit={this.resetCloseErrorSubmit}
        //  sendSupportMessage={this.sendSupportMessage}
        setSupportAsRead={setSupportRead}
        resetErrorNotification={this.resetErrorNotification}
        closeLevelNotification={closeLevelUpNotification}
        sendGift={this.sendGift}
        //  blockUser={blockThisUser}
        //  unBlockUser={unBlockThisUser}
        playButtonSound={this.playButtonSound}
        fetchGifts={this.fetchGifts}
        fetchDrinkGifts={this.fetchDrinkGifts}
        setShowEndResultModal={this.setShowEndResultModal}
        toggleScoreTable={toggleScoreTableFunc}
        toggleMobileScoreTable={toggleMobileScoreTableFunc}
        isFullscreen={isFullscreen}
        isFullscreenEnabled={isFullscreenEnabled}
        isWebVersion={isWebVersion}
        toggleFullscreen={toggleFullscreen}
        //  setProfanitiesNotif={setProfanitiesNotif}
        profanitiesList={profanitiesList}
        profanitiesNotification={profanitiesNotification}
        notificationSettings={notificationSettings}
        gameSettings={gameSettings}
        fetchCardsOnTable={this.fetchCardsOnTable}
        toggleNewDesign={toggleNewDesign}
        toggleScreenMode={toggleScreenMode}
        cardsOnLoading={cardsOnLoading}
        toggleCardsOnLoading={this.toggleCardsOnLoading}
        screenMode={screenMode}
        fontMode={fontMode}
        toggleFont={toggleFont}
        lastRound={lastRound}
        bannerVisible={bannerVisible}
      />
    );
  };
}

const mapStateToProps = (state) => {

  let localScreenMode;

  try {
    if ((localStorage && localStorage.getItem('screenMode'))) { //x
      localScreenMode = localStorage.getItem('screenMode'); //x
    }
  } catch (err) {
    console.log(err);
  }

  return ({
    //  notificationSettings,
    notificationSettings: state.userSettings ? ((state.userSettings[state.member.uid] && state.userSettings[state.member.uid].notificationSettings) ? (state.userSettings[state.member.uid].notificationSettings) : (state.userSettings.default ? state.userSettings.default.notificationSettings : null)) : {},
    gameSettings: (state.userSettings[state.member.uid] && state.userSettings[state.member.uid].gameSettings) ? (state.userSettings[state.member.uid].gameSettings) : (state.userSettings.default ? state.userSettings.default.gameSettings : null),
    globalParams: state.game.globalParams || {},
    currentType: state.game.currentType || null,
    cards: state.game.cards || [],
    automated: state.game.automated || null,
    myPos: state.game.myPos || null,
    lastRoom: state.game.lastRoom || null,
    lastRound: state.game.globalParams.lastRound,
    players: state.game.players,

    member: {
      uid: state.member.uid,
      name: state.member.name,
      lvl: state.member.level,
      lvlUpNotification: state.member.lvlUpNotification,
      gPlayed: state.member.gPlayed,
      supportChat: state.member.supportChat,
      supportChatStatus: state.member.supportChatStatus,
      offset: state.member.offset,
      offsetWithTimezone: state.member.offsetWithTimezone,
      activeRoom: state.member.activeRoom,
      role: state.member.role,
    },
    //  userSettings: state.userSettings || {},
    userSettings: state.userSettings[state.member.uid] ? (state.userSettings[state.member.uid]) : (state.userSettings.default ? state.userSettings.default : {}),
    soundOn: state.userSettings.soundOn,
    state: state.state || false,
    cardsOnTable: state.game.cardsOnTable || [],
    screenMode: state.member.screenMode ? state.member.screenMode : (localScreenMode || constants.SCREEN_MODE.normal),
  });
};

const mapDispatchToProps = {
  fetchCards: getCardsStudentZole,
  fetchAutomatedStatus: getAutomatedStatus,
  playACard: playCardStudentZole,
  fetchCurrentTable: getCurrentTable,
  fetchGlobalParams: getGlobalParams,
  chooseGameType: selectGameTypeStudentZole,
  fetchPlayers: getPlayers,
  //  fetchPlayersWeb: getPlayersWeb,
  fetchPlayerPosition: getPlayerPosition,
  fetchCurrentTurn: getCurrentTurn,
  fetchFirstToGo: getFirstToGo,
  fetchSittingOut: getSittingOut,
  fetchLargePlayer: getLargePlayer,
  fetchCurrentType: getCurrentType,
  fetchNextTimeStamp: getNextTimeStamp,
  fetchUnlimitedTimerStarted: getUnlimitedTimerStarted,
  endThisRoom: endRoom2,
  leaveThisRoom: leaveRoom,
  //  lastRound: setLastRound,
  //  quitThisRound: quitRound,
  resetStore: resetGameStore,
  closeResultNotif: closeResultNotification,
  //  sendSupportMsg: sendSupportMessage,
  setSupportRead: setSupportAsRead,
  //  disableTime: disableTimer,
  //  setNextDeal: setNextDealCards,
  //  setMyUserBal: setUserBal,
  sendAGift: sendGift,
  fetchGifts: getGifts,
  fetchDrinkGifts: getDrinkGifts,
  fetchRoomGifts: getRoomGifts,
  //  blockThisUser: blockUser,
  //  unBlockThisUser: unBlockUser,
  updateLastLogin: updateUserLastLogin,
  closeLevelUpNotification: closeLevelNotification,
  //  fetchPreviousRound: getPreviousRound,
  removeCurActiveRoom: removeActiveRoom,
  setLoadingFunc: setLoading,
  setRoomId: setCurRoomId,
  fetchInitialData: fetchInitialRoomData,
  refreshDbLastToken: refreshLastToken,
  toggleScoreTableFunc: toggleScoreTable,
  toggleMobileScoreTableFunc: toggleMobileScoreTable,
  //  debugParam: debugSetParam,
  //  fetchUserInfo: getOtherUserInfo,
  getOffset: getTimeOffset,
  fetchIgnoredPlayers: getIgnoredPlayers,
  fetchProfanitiesList: getProfanitiesList,
  //  setProfanitiesNotif: setProfanitiesNotification,
  fetchCardsOnTable: getCardsOnTable,
  resetFilterRooms: resetFilterRoomsExit,

  readChatMessages: readChat,
  fetchPoints: getPoints,
  fetchPules: getPules,
  cancelListeners: cancelPointsListeners,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StudentZole));
